import { useTranslation } from 'react-i18next';

function ManualPaymentSuccessModal({ closeModal, orderData, paymentMethod }) {
    const { t } = useTranslation();

    const handleClose = () => {
        closeModal();
        window.location.href = '/student-learning?courses';
    };

    return (
        <>
            <div className="lrf_modal">
                <h2>{t('manualPaymentSuccess.title')}</h2>
            </div>
            <div className="lrf_subtext">
                <div style={{ textAlign: 'left' }}>
                    <p style={{ fontSize: '16px', fontWeight: '700', marginBottom: '10px' }}>
                        {t('manualPaymentSuccess.orderId')}: <span style={{ color: '#0b4475' }}>#{orderData?.id}</span>
                    </p>
                    <p style={{ fontSize: '16px', fontWeight: '700', marginBottom: '10px' }}>
                        {t('manualPaymentSuccess.amount')}: <span style={{ color: '#0b4475' }}>{orderData?.currency} {orderData?.final_total}</span>
                    </p>
                    <p style={{ fontSize: '14px', marginBottom: '10px' }}>
                        <strong>{t('manualPaymentSuccess.paymentMethod')}:</strong> {paymentMethod?.alias}
                    </p>
                    <div className="payment-details-box">
                        <p>
                            <strong>{t('manualPaymentSuccess.accountDetails')}:</strong>{' '}
                            {paymentMethod?.account_details}
                        </p>
                        <p>
                            <strong>{t('manualPaymentSuccess.transferDetails')}:</strong>{' '}
                            {paymentMethod?.transfer_details}
                        </p>
                    </div>
                </div>
            </div>
            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: '10px' }}>
                <button className="btn_primary" onClick={handleClose}>
                    {t('manualPaymentSuccess.goToOrders')}
                </button>
            </div>
        </>
    );
}

export default ManualPaymentSuccessModal;
